import { Plugin } from "ckeditor5";

export default class ExpandResponseWithContextUI extends Plugin {
  public static get pluginName(): string {
    return "ExpandResponseWithContextUI";
  }
}
